import { render, staticRenderFns } from "./MultiCurrencyConfigSidebar.vue?vue&type=template&id=5ccc85a1&"
import script from "./MultiCurrencyConfigSidebar.vue?vue&type=script&lang=js&"
export * from "./MultiCurrencyConfigSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports